module.exports = __webpack_public_path__ + "img/3.d83f30ae.jpg";